angular.module('iw.frontyard.repayment_calculator')
    .directive('iwFormatLoanAmount', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elt, attrs, ngModel) {
                ngModel.$formatters.push(function (value) {
                    value = Math.round(value * value / 500) * 500;
                    return value;
                });
                ngModel.$parsers.push(function (value) {
                    value = Math.pow(value, 1 / 2);
                    return value;
                });
            }
        };
    });
